<template>
    <div class="form-create-wrapper"
         :style="{height: createHeight}">
      <div :class="wrapperClasses">
        <v-icon type="iconclear-24px"
                right-text="退出"
                @click.native="handleBack"
                class="form-create-wrapper__close"></v-icon>
        <div class="form-create-wrapper__title">{{title}}</div>
        <div class="form-create-wrapper__body">
          <slot></slot>
        </div>
        <div class="form-create-wrapper__footer">
          <Button type="text"
                  @click="handlePrevBtnClick"
                  v-if="prevBtnShow">上一步</Button>
          <Button type="primary"
                  @click="handleNextBtnClick"
                  :loading="nextBtnLoading"
                  :disabled="nextBtnDisabled"
                  shape="circle">{{nextBtnName}}</Button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'contractCreateWrapper',
  props: {
    className: String,
    nextBtnDisabled: Boolean,
    nextBtnLoading: Boolean,
    nextBtnName: String,
    prevBtnShow: Boolean,
    title: {
      default: '提交新合同',
      type: String,
    },
  },
  computed: {
    ...mapState(['windowSize']),
    createHeight() {
      return `${this.windowSize.height - 48}px`;
    },
    wrapperClasses() {
      return `form-create-main ${this.className || ''}`;
    },
  },
  methods: {
    handleNextBtnClick() {
      this.$emit('on-next-btn-click');
    },
    handlePrevBtnClick() {
      this.$emit('on-prev-btn-click');
    },
    handleBack() {
      this.$router.push({
        name: 'dashboard-settlement-contract',
      });
    },
  },
};
</script>

<style lang="less">
  .form-create-wrapper{
    position: relative;
    overflow: auto;
    margin-top: -48px;
    .form-create-main{
      position: absolute;
      top: 86px;
      width: 1008px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      border-radius: 8px;
      min-height: 448px;
      .box-shadow;
    }
    &__close{
      position: absolute;
      top: -40px;
      left: 8px;
      color: @primary-color;
      font-weight: 500;
      cursor: pointer;
    }
    &__title{
      height: 55px;
      line-height: 55px;
      padding-left: 16px;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.54);
      font-weight: 500;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
    &__body{
      padding: 16px 16px 48px;
    }
    &__footer{
      position: absolute;
      right: 8px;
      bottom: -66px;
      padding-bottom: 16px;
      .ivu-btn{
        padding: 0;
        width: 88px;
        height: 36px;
        margin-left: 8px;
        font-weight: bold;
        box-shadow: none;
        &.ivu-btn-text{
          background-color: transparent;
          color: @primary-color;
        }
      }
    }
  }
</style>
